import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MonthPerformanceService {

  constructor(private http: HttpClient) { }

  getMonthPerformance(): Observable<Object[]> {
    
    let url=`${environment.api.uri}v1.0/performance/month?kpidate=2024-01`;
    return this.http.get<Object[]>(url);
  }

  getMonthPerformanceByApexIdAndMonth(apexId:string, month:string): Observable<Object[]> {
    let url=`${environment.api.uri}v1.0/performance/month?apexid=${apexId}&kpidate=${month}`;
    return this.http.get<Object[]>(url);
  }

  // v1.0/performance?apexid=zhangw13&businesstype=PG&country=CN&kpidate=2024-02-01&kpidate=2024-02-01
  getMonthPerformanceByApexIdStartEndMonthCountryBusinessType(apexId:string, startMonth:string, endMonth:string, driverCountry:string, driverBusinessType:string): Observable<Object[]> {
    let url=`${environment.api.uri}v1.0/performance?apexid=${apexId}&kpidate=${startMonth}&kpidate=${endMonth}&country=${driverCountry}&businesstype=${driverBusinessType}`;
    return this.http.get<Object[]>(url);
  }

  getMonthPerformanceByApexIdMonthCountryBusinessType(apexId:string, month:string, driverCountry:string, driverBusinessType:string): Observable<Object[]> {
    let url=`${environment.api.uri}v1.0/performance?apexid=${apexId}&kpidate=${month}&country=${driverCountry}&businesstype=${driverBusinessType}`;
    return this.http.get<Object[]>(url);
  }

  // today is 20240322
  // v1.0/performance?apexid=zhangw13&businesstype=PG&country=CN&kpidate=2023-10-01&kpidate=2024-02-29
  getYearPerformanceByApexIdMonthCountryBusinessType(apexId:string, startMonth:string, endMonth:string, driverCountry:string, driverBusinessType:string): Observable<Object[]> {
    let url=`${environment.api.uri}v1.0/performance?apexid=${apexId}&kpidate=${startMonth}&kpidate=${endMonth}&country=${driverCountry}&businesstype=${driverBusinessType}`;
    return this.http.get<Object[]>(url);
  }

  // v1.0/kpi/others/3/attachment
  getOthersKpiAttachment(kpiOthersId:number): Observable<string> {
    let url=`${environment.api.uri}v1.0/kpi/others/${kpiOthersId}/attachment`;
    
    return this.http.get<string>(url, { responseType: 'text' as 'json' });
  }

  getOthersKpiAttachmentV2(kpiOthersId:number): Observable<any> {
    let url=`${environment.api.uri}v1.0/kpi/others/${kpiOthersId}/attachment`;
    
    return this.http.get(url, { responseType: 'blob'  });
  }

  
}
